import styled from "styled-components";
import { Type } from "discover.medical.react-component-library";

export const TitleRoot = styled(Type)`
  margin-right: ${({ theme }) => theme.space.sm};
  & p {
    margin: 0;
  }
`;
